import PropTypes from 'prop-types';
import React from 'react';

import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';

import Button from 'components/buttons/Button';
import InputFieldText from 'components/form/inputFields/InputFieldText/InputFieldText';
import { LOGIN_PATH } from 'constants/paths';
import { REGEX_EMAIL } from 'constants/regex';

const SignupMemberForm = ({ onSubmit, companyName, email }) => {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, isValid },
  } = useForm({
    mode: 'onChange',
    nativeValidation: false,
    defaultValues: {
      email,
    },
  });

  return (
    <div className="mt-16 sm:mx-auto sm:w-full sm:max-w-md">
      <h2 className="text-lg font-bold text-gray-700 mb-2 text-center">
        Join {companyName}
      </h2>
      <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form className="space-y-3" onSubmit={handleSubmit(onSubmit)}>
          <InputFieldText
            {...register('firstName', {
              required: true,
            })}
            type="text"
            required
          >
            <InputFieldText.Label>First name</InputFieldText.Label>
          </InputFieldText>
          <InputFieldText
            {...register('lastName', {
              required: true,
            })}
            type="text"
            required
          >
            <InputFieldText.Label>Last name</InputFieldText.Label>
          </InputFieldText>
          <InputFieldText
            {...register('email', {
              pattern: REGEX_EMAIL,
            })}
            type="email"
            autoComplete="email"
            disabled
            required
          >
            <InputFieldText.Label>Email address</InputFieldText.Label>
          </InputFieldText>
          <InputFieldText
            {...register('password', {
              required: true,
            })}
            type="password"
            required
          >
            <InputFieldText.Label>Password</InputFieldText.Label>
          </InputFieldText>
          <div className="pt-4">
            <Button size="base" submit full disabled={isSubmitting || !isValid}>
              {isSubmitting ? 'Loading' : 'Sign up'}
            </Button>
          </div>
        </form>
      </div>

      <div className="py-4 flex justify-center">
        <Link
          to={LOGIN_PATH}
          className="font-medium text-teal-500 hover:text-teal-500"
        >
          Or sign in if you have an account
        </Link>
      </div>
    </div>
  );
};

SignupMemberForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  companyName: PropTypes.string,
  email: PropTypes.string,
};

export default SignupMemberForm;
